<div class="min-h-screen flex flex-col bg-age-cream text-age-green font-segoe">
  <header class="flex flex-col items-center pt-10 pb-6">
    <img src="logo.png" alt="AGE" class="h-14 mb-4" />
    <h1 class="text-2xl md:text-3xl font-semibold">
      PRÉ-INSCRIPTION ENREGISTRÉE
    </h1>
    <p class="text-base mt-2 text-age-green uppercase fobnt-bold">
      Inscription en attente de paiement
    </p>
  </header>

  @if(registration$ | async; as registration){
  <main class="flex-1 flex flex-col items-center px-4 md:px-6 pb-20 gap-10">
    <section
      class="w-full max-w-[900px] bg-white border border-age-brown rounded-[30px] p-8 md:p-12 shadow-sm"
    >
      <h2 class="text-xl md:text-2xl font-bold text-center mb-2">
        ÉTAPES À SUIVRE
      </h2>
      <p class="text-center text-sm text-age-primary mb-8">
        Merci de compléter les étapes ci-dessous pour valider votre inscription.
      </p>

      <div class="mb-8">
        <h3 class="font-bold mb-2">Étape 1 – Effectuer le virement bancaire</h3>
        <p class="text-sm text-age-primary mb-4">
          Merci d’effectuer un virement du montant suivant :
          <span class="font-semibold text-age-green"
            >{{ registration.totalAmount | number: '' : 'fr-FR' }} DH</span
          >
        </p>

        <div
          class="border border-age-brown/40 rounded-2xl p-4 md:p-6 space-y-3 text-sm divide-y divide-age-brown/20"
        >
          <div class="flex justify-between items-center px-2 py-2">
            <span>Banque :</span>
            <span class="font-bold text-age-brown">{{ bank.NAME }}</span>
          </div>

          <div class="flex justify-between px-2 py-2">
            <span>RIB :</span>
            <span
              class="font-bold flex items-center gap-2 text-age-brown relative"
            >
              {{ bank.RIB }}
              <button
                type="button"
                class="cursor-pointer relative"
                (click)="copyRib(bank.RIB)"
              >
                <lib-copy />
              </button>

              <span
                class="absolute -top-8 right-0 text-xs bg-black text-white px-2 py-1 rounded transition-all duration-200"
                [class.opacity-100]="copied"
                [class.opacity-0]="!copied"
              >
                Copié !
              </span>
            </span>
          </div>

          <div class="flex justify-between px-2 py-2">
            <span>Titulaire :</span>
            <span class="font-bold text-age-brown">{{ bank.OWNER }}</span>
          </div>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="mb-8">
        <h3 class="font-bold mb-2">Étape 2 – Envoyer la preuve de paiement</h3>
        <p class="text-sm text-age-primary">
          Après le virement, envoyez la preuve de paiement (reçu ou capture) à
          l’adresse suivante :
          <span class="font-bold text-age-green">contact@1of1events.com</span>,
          avec l’objet : @if(participant(registration); as participant){
          <em class="font-bold text-age-green"
            >“Preuve de paiement – {{ participant.familyName + ' ' +
            participant.firstName }}”</em
          >.}
        </p>
      </div>

      <!-- Step 3 -->
      <div>
        <h3 class="font-bold mb-2">
          Étape 3 – Réception de la confirmation finale
        </h3>
        <p class="text-sm text-age-primary">
          Après vérification de votre paiement, vous recevrez un email de
          confirmation d’inscription.
        </p>
        <p class="text-sm mt-1 text-age-primary">
          Votre inscription sera alors définitivement validée.
        </p>
      </div>
    </section>

    <section
      class="w-full max-w-[900px] bg-white border border-age-brown rounded-[30px] p-8 md:p-12 shadow-sm"
    >
      <h2 class="text-xl md:text-2xl font-bold text-center mb-8">
        INFORMATIONS ENREGISTRÉES
      </h2>

      @if(registration.company){
      <div
        class="border border-age-brown/40 rounded-2xl overflow-hidden text-sm mb-4"
      >
        <div class="px-4">
          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-green text-2xl font-bold">Entreprise</span>
          </div>
          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Nom de l'entreprise :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.company.name }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">ICE :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.company.ice }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Adresse postale :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.company.address }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Ville :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.company.city }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Pays :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.company.country }}
            </span>
          </div>
        </div>
      </div>

      } @if(registration.representative){
      <div
        class="border border-age-brown/40 rounded-2xl overflow-hidden text-sm mb-4"
      >
        <div class="px-4">
          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-green text-2xl font-bold"
              >Représentative</span
            >
          </div>
          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Nom complet :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.representative.fullName }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Email :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.representative.email }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Téléphone :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.representative.phoneNumber }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Role :</span>
            <span class="font-bold text-age-brown text-right">
              {{ registration.representative.role }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary"
              >Remarque ou demandes particulières :</span
            >
            <span class="font-bold text-age-brown text-right">
              {{ registration?.comment }}
            </span>
          </div>
        </div>
      </div>
      } @for (participant of registration.participants; track $index) {
      <div
        class="border border-age-brown/40 rounded-2xl overflow-hidden text-sm mb-4"
      >
        <div class="px-4">
          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-green text-2xl font-bold"
              >Participant {{ registration.participants.length > 1 ? $index + 1
              : '' }}</span
            >
          </div>
          @if(registration.type === 'SIMPLE') {
          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Type de pass :</span>
            <span class="font-bold text-age-brown text-right">
              {{ displayPass(registration.pass) }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>
          }

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Nom :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.familyName }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Prénom :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.firstName }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Profession :</span>
            <span class="font-bold text-age-brown text-right">
              {{ displayProfession(participant.profession) }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Spécialité :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.speciality }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Numéro de téléphone :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.phoneNumber }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Adresse email :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.email }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Ville :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.city }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Pays :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participant.country }}
            </span>
          </div>
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary">Hébérgement :</span>
            <span class="font-bold text-age-brown text-right">
              {{ participantAccom(registration.participants, $index) }}
            </span>
          </div>
          @if(registration.type === 'SIMPLE' || registration.type ===
          'WITH_ACCOMODATION') {
          <div class="mx-1 h-px bg-age-brown/20"></div>

          <div class="grid grid-cols-[auto_1fr] items-center py-2">
            <span class="text-age-primary"
              >Remarque ou demandes particulières :</span
            >
            <span class="font-bold text-age-brown text-right">
              {{ registration.comment }}
            </span>
          </div>
          }
        </div>
      </div>
      }

      <div
        class="flex justify-between items-center px-6 py-4 border-t border-age-brown/30 mt-6"
      >
        <span class="text-2xl font-semibold text-age-primary"
          >Total à payer</span
        >
        <span class="text-2xl font-bold text-age-green"
          >{{ registration.totalAmount | number: '' : 'fr-FR' }} DH</span
        >
      </div>
    </section>
    <div
      class="flex flex-col md:flex-row justify-between items-center gap-4 mt-4 space-x-40"
    >
      <button
        (click)="goBack()"
        class="flex items-center gap-2 text-age-green/80 hover:text-age-green font-medium uppercase !text-sm tracking-widest transition-all duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-age-green after:transition-all after:duration-300 hover:cursor-pointer hover:after:w-full"
      >
        <lib-arrow-left></lib-arrow-left>
        <span class="leading-none"> Retour à l'accueil </span>
      </button>
      <button
        (click)="downloadQuote()"
        [disabled]="isLoading()"
        class="bg-age-green text-white px-6 py-3 rounded-xl hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
      >
        @if (!isLoading()) { Télécharger le devis }@else {
        <span class="rounded-full animate-spin"></span>
        <span>Traitement...</span>
        }
      </button>
    </div>
  </main>
  }

  <lib-footer />
</div>
